import trainModel from "../../../../models/custom-vision/custom-vision.trains.model";
import ViewBase from '../../../view-base.view';
import CommonFooterComponent from "../common-footer.component";

export default function CVTrainingPerformanceEvaluateView() {
  ViewBase.call(this);

  let selectedRecord;
  let selectedPredictionId = '';
  let currentSubmissionScore = 0;
  let currentAdjustedScore = 0;
  let inputDataModel = { score: '' };

  let onPopupClose = (e) => { };
  let onSaveComplete = (e) => { };

  let _cancel = (e) => {
    onPopupClose(e);
  }

  let _save = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    trainModel.updateScore(
      (result) => {
        onSaveComplete(result);
      },
      (error) => {
        this.handleError(error);
      },
      selectedPredictionId,
      inputDataModel.score
    );
  }

  let _getScore = (e) => {
    inputDataModel.score = parseFloat(e.target.value);
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onPopupClose) {
        onPopupClose = vnode.attrs.onPopupClose;
      }

      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }

      if (vnode.attrs.record) {
        selectedRecord = vnode.attrs.record;
        selectedPredictionId = vnode.attrs.record.transactionId;
        currentSubmissionScore = vnode.attrs.record.submissionScore;
        currentAdjustedScore = vnode.attrs.record.adjustedScore;
      }
    },
    view: () => {
      let _recordScoreTextCss = '.bg-primary';

      if (currentAdjustedScore < selectedRecord.warningScore) {
        _recordScoreTextCss = '.bg-warning.text-dark';
      }

      if (currentAdjustedScore < selectedRecord.alertingScore) {
        _recordScoreTextCss = '.bg-danger';
      }

      return [
        m('.row',
          m('col-md-12',
            m('.card',
              m('.card-body',
                m('form#mainForm[novalidate].needs-validation',
                  m('.row.col-md-12',
                    m('.col-md-12.mt-4',
                      m('label',
                        this.getText("LT00000393", "Adjusted Score"),
                        m('span.badge.rounded-pill.ms-3' + _recordScoreTextCss, currentAdjustedScore.toFixed(2))
                      ),
                    ),
                    m('.col-md-12.mt-4',
                      m('label',
                        this.getText("LT00000394", "Submitted Score"),
                        m('span.badge.rounded-pill.bg-secondary.ms-3', currentSubmissionScore.toFixed(2))
                      ),
                    ),
                    m('.col-md-12.mt-4',
                      m('label.form-label', this.getText("LT00000395", "New Score"), m('span.redText', "*")),
                      m('input.form-control.form-control-bg[required]', {
                        type: 'number',
                        maxlength: 6,
                        placeholder: this.getText("LT00000395", "New Score"),
                        value: inputDataModel.score,
                        onchange: _getScore
                      }),
                      m('.invalid-feedback', this.getText("LT00000396", "Please enter a valid score (from 0 to 100)."))
                    ),
                  )
                )
              ),
              m(CommonFooterComponent, {
                actionHandler: _save,
                cancelHandler: _cancel,
              }),
            )
          ),
        ),
        this.getBaseViews()
      ];
    },
  };
}
